<template>
  <b-row>
    <b-col md="6">
      <b-form-group>
        <b-form-select
          class="mv-form-control form-control"
          id="order"
          size="sm"
          v-model="selectedSortMethod"
          :options="sortMethods"
          @change="$emit('sort', selectedSortMethod)"
          ></b-form-select>
      </b-form-group>
    </b-col>
    <b-col md="6">
      <b-form-group>
        <b-form-select
          class="mv-form-control form-control"
          id="itemsPerPage"
          size="sm"
          v-model="selectedResultsPerPage"
          :options="resultsPerPage"
          @change="$emit('pagination', selectedResultsPerPage)"
          >
          </b-form-select>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import formMixin from '@/app/private/shared/mixins/search_forms'

export default {
  name: 'SortFields',
  mixins: [formMixin]
}

</script>
